import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { AdminPageStyle } from "../../pages/admin/style";
import React, { useEffect } from "react";

export const CycleYearInfo = ({ yearData, setYearData, cycleYear, fleetTypeId }) => {
  const classes = AdminPageStyle();

  useEffect(() => {
    const hasAnyYearSelected =
      yearData?.year1 ||
      yearData?.year2 ||
      yearData?.year3 ||
      yearData?.year4 ||
      yearData?.year5;

    if (!hasAnyYearSelected && !cycleYear) {
      setYearData({
        ...yearData,
        year1: true,
        year2: true,
        year3: true,
        year4: true,
        year5: true,
      });
    }
  }, [fleetTypeId, cycleYear, yearData]);

  const handleYearChange = (e, data) => {
    if (e.target.checked) {
      let obj = {
        ...yearData,
        [`year${data}`]: true,
      };

      setYearData(obj);
    } else {
      let obj = {
        ...yearData,
        [`year${data}`]: false,
      };
      setYearData(obj);
    }
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={6}>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          className={classes.textGeneralInfo}
        >
          cycle year information
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListTotalMileageText}>
                  Year 1
                </span>
                <span className={classes.fleetListGenInfoTtext}>
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={yearData?.year1 !== undefined ? yearData.year1 : cycleYear?.year1 || false}
                        disabled={cycleYear ? true : false}
                        onChange={(e) => handleYearChange(e, 1)}
                      />
                    }
                  />
                </span>
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListTotalMileageText}>
                  Year 2
                </span>
                <span className={classes.fleetListGenInfoTtext}>
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={yearData?.year2 !== undefined ? yearData.year2 : cycleYear?.year2 || false}
                        disabled={cycleYear ? true : false}
                        onChange={(e) => handleYearChange(e, 2)}
                      />
                    }
                  />
                </span>
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListTotalMileageText}>
                  Year 3
                </span>
                <span className={classes.fleetListGenInfoTtext}>
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={yearData?.year3 !== undefined ? yearData.year3 : cycleYear?.year3 || false}
                        disabled={cycleYear ? true : false}
                        onChange={(e) => handleYearChange(e, 3)}
                      />
                    }
                  />
                </span>
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListTotalMileageText}>
                  Year 4
                </span>
                <span className={classes.fleetListGenInfoTtext}>
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={yearData?.year4 !== undefined ? yearData.year4 : cycleYear?.year4 || false}
                        disabled={cycleYear ? true : false}
                        onChange={(e) => handleYearChange(e, 4)}
                      />
                    }
                  />
                </span>
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListTotalMileageText}>
                  Year 5
                </span>
                <span className={classes.fleetListGenInfoTtext}>
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={yearData?.year5 !== undefined ? yearData.year5 : cycleYear?.year5 || false}
                        disabled={cycleYear ? true : false}
                        onChange={(e) => handleYearChange(e, 5)}
                      />
                    }
                  />
                </span>
              </Box>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};
